import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { AlertOctagon } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const fmt = (iso) => (iso ? iso.slice(0, 16).replace('T', ' ') : '');

export const PerformanceNoticesAdmin = () => {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState('all');
  const headers = { Authorization: `Bearer ${localStorage.getItem('token') || sessionStorage.getItem('token')}` };

  const load = useCallback(async () => {
    const q = status === 'all' ? '' : `?status=${status}`;
    const r = await axios.get(`${API_URL}/api/driver-trips/notices${q}`, { headers }).catch(() => ({ data: [] }));
    setRows(r.data || []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);
  useEffect(() => { load(); }, [load]);

  return (
    <Card data-testid="performance-notices-admin">
      <CardHeader className="flex flex-row flex-wrap items-center justify-between gap-2 space-y-0 pb-2">
        <CardTitle className="text-base flex items-center gap-2"><AlertOctagon className="h-5 w-5 text-red-600" /> Performance Notices ({rows.length})</CardTitle>
        <Select value={status} onValueChange={setStatus}>
          <SelectTrigger className="w-44" data-testid="performance-notices-status-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All notices</SelectItem>
            <SelectItem value="pending">Not acknowledged</SelectItem>
            <SelectItem value="acknowledged">Acknowledged</SelectItem>
          </SelectContent>
        </Select>
      </CardHeader>
      <CardContent>
        {rows.length === 0 ? (
          <p className="text-sm text-muted-foreground py-4 text-center">No performance notices issued.</p>
        ) : (
          <div className="overflow-x-auto border rounded">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Staff</TableHead><TableHead>Week</TableHead><TableHead className="text-right">Avg/day at notice</TableHead>
                  <TableHead>Grade</TableHead><TableHead className="text-right">Current avg</TableHead><TableHead>Issued</TableHead><TableHead>Acknowledged</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {rows.map((n) => (
                  <TableRow key={n.id} data-testid={`performance-notice-row-${n.id}`}>
                    <TableCell className="font-semibold">{n.driver_name}</TableCell>
                    <TableCell className="text-xs whitespace-nowrap">{n.week_start} – {n.week_end}</TableCell>
                    <TableCell className="text-right">{n.avg_per_day}</TableCell>
                    <TableCell><Badge variant="outline" className="border-red-300 text-red-700">{n.grade || '—'}</Badge></TableCell>
                    <TableCell className="text-right">{n.latest_avg} {n.latest_grade ? `(${n.latest_grade})` : ''}</TableCell>
                    <TableCell className="text-xs whitespace-nowrap">{fmt(n.issued_at)}</TableCell>
                    <TableCell className="text-xs whitespace-nowrap">
                      {n.acknowledged_at ? <span className="text-emerald-700">{fmt(n.acknowledged_at)}</span> : <Badge className="bg-red-600 hover:bg-red-600">Pending</Badge>}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
